/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 05 2024
 **/

import { _T } from "@rfice/language";
import { useTheme } from "@emotion/react";

import { Column, Typography } from "@/frameworks/designStuff/components";
import { Utility } from "@/frameworks/libraries/utilities";
import useDocumentViewerStore from "../stores/useDocumentViewerStore";

export default function EmptyViewer() {
	const theme = useTheme();
	const scale = useDocumentViewerStore((state) => state.scale);

	return (
		<Column
			verticalAlign="center"
			horizonAlign="center"
			css={{
				height: "100%",
				aspectRatio: "1.77",
				backgroundColor: theme.colors.neutral_90_100,
				scale: `${scale}`
			}}
		>
			<Typography
				typoSize={Utility.isMobile ? "Title3_B" : "Head5_B"}
				typoColor="neutral_00_100"
				css={{ paddingLeft: "16px", paddingRight: "16px", width: "100vw", textAlign: "center" }}
			>
				{_T("미리보기를 지원하지 않는 파일 형식입니다")}
			</Typography>
		</Column>
	);
}
